import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getCentros() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}centros`);
    return response

  } catch (error) {
    console.error('Error al obtener los centros', error);
  }
}